import { z } from 'zod';

const optionalText = (max, label) => z
  .string()
  .max(max, `${label}最多 ${max} 字`)
  .optional()
  .or(z.literal(''));

function positiveQty(value) {
  return value !== '' && value != null && !Number.isNaN(Number(value)) && Number(value) > 0;
}

function nonNegativeQty(value) {
  return value !== '' && value != null && !Number.isNaN(Number(value)) && Number(value) >= 0;
}

const materialRowSchema = z.object({
  id: z.string().optional(),
  mtrId: z.string().trim().min(1, '請選擇物料'),
  mtrNo: z.string().optional().or(z.literal('')),
  mtrName: z.string().optional().or(z.literal('')),
  baseUnitName: z.string().optional().or(z.literal('')),
  qtyPerProduct: z.union([z.string(), z.number()]).refine(positiveQty, {
    message: '每產品用量須大於 0',
  }),
  remark: optionalText(500, '備註'),
});

const extraItemRowSchema = z.object({
  id: z.string().optional(),
  itemName: z.string().trim().min(1, '項目名稱不能為空').max(100, '項目名稱最多 100 字'),
  qtyPerProduct: z.union([z.string(), z.number()]).refine(nonNegativeQty, {
    message: '數量須大於等於 0',
  }),
  unitName: optionalText(50, '單位'),
  remark: optionalText(500, '備註'),
});

export const productFormSchema = z.object({
  productNo: z.string().trim().min(1, '產品代號不能為空').max(50, '產品代號最多 50 字'),
  name: z.string().trim().min(1, '名稱不能為空').max(100, '名稱最多 100 字'),
  salesUnitName: z.string().trim().min(1, '銷售單位不能為空').max(50, '銷售單位最多 50 字'),
  customerId: z.string().optional().or(z.literal('')),
  customerProductNo: optionalText(100, '客戶料號'),
  remark: optionalText(500, '備註'),
  materials: z.array(materialRowSchema).min(1, '請至少選一筆物料'),
  extraItems: z.array(extraItemRowSchema),
}).superRefine((data, ctx) => {
  const seen = new Set();
  (data.materials ?? []).forEach((row, index) => {
    const mtrId = String(row?.mtrId ?? '').trim();
    if (!mtrId) {
      return;
    }
    if (seen.has(mtrId)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: '物料不可重複',
        path: ['materials', index, 'mtrId'],
      });
      return;
    }
    seen.add(mtrId);
  });
});

export const PRODUCT_FORM_DEFAULT_VALUES = {
  productNo: '',
  name: '',
  salesUnitName: '',
  customerId: '',
  customerProductNo: '',
  remark: '',
  materials: [],
  extraItems: [],
};
